module.exports = __webpack_public_path__ + "static/img/3.cda3a11b.svg";